var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_167983",
    "data-name": "Group 167983",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_167543",
    "data-name": "Path 167543",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "#4b8aeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-attach",
    "data-name": "Icon ionic-ios-attach",
    d: "M15.67,5.723a.42.42,0,0,0-.42.42v5.23a2.17,2.17,0,0,1-.592,1.482,2.129,2.129,0,0,1-1.493.638H12.8a2.091,2.091,0,0,1-1.474-.662,2.16,2.16,0,0,1-.643-1.485V4.6a1.462,1.462,0,0,1,.465-1.063,1.6,1.6,0,0,1,1.1-.439,1.5,1.5,0,0,1,1.512,1.5v6.3a.85.85,0,0,1-.78.866.827.827,0,0,1-.759-.866V7.305a.42.42,0,0,0-.839,0V10.9a1.614,1.614,0,0,0,2.747,1.211A1.7,1.7,0,0,0,14.6,10.9V4.6a2.352,2.352,0,0,0-2.36-2.349,2.361,2.361,0,0,0-1.673.686,2.321,2.321,0,0,0-.7,1.665v6.748a3.007,3.007,0,0,0,.877,2.1,2.908,2.908,0,0,0,2.047.858h.366a2.939,2.939,0,0,0,2.042-.864,3.022,3.022,0,0,0,.643-.931,2.817,2.817,0,0,0,.239-1.133V6.143A.416.416,0,0,0,15.67,5.723Z",
    transform: "translate(-0.872 3.749)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.2884bb8a7e57c6eef961ae881865ca7f.svg";
export { ForwardRef as ReactComponent };